import axiosInstance from "./axiosConfig";

// API endpoint for auth
const AUTH_URL = "/auth";

/**
 * Register a new user
 * @param {Object} userData - User registration data
 * @returns {Object} User data with token
 */
const register = async (userData) => {
  const response = await axiosInstance.post(`${AUTH_URL}/register`, userData);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }

  return response.data;
};

/**
 * Login a user
 * @param {Object} userData - User credentials
 * @returns {Object} User data with token
 */
const login = async (userData) => {
  const response = await axiosInstance.post(`${AUTH_URL}/login`, userData);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }

  return response.data;
};

/**
 * Logout a user
 */
const logout = async () => {
  // Call the logout endpoint (optional, since JWT is stateless)
  try {
    await axiosInstance.post(`${AUTH_URL}/logout`);
  } catch (error) {
    console.error("Logout error:", error);
  }

  // Remove user from local storage
  localStorage.removeItem("user");
};

/**
 * Get current user profile
 * @returns {Object} User profile data
 */
const getProfile = async () => {
  const response = await axiosInstance.get(`${AUTH_URL}/profile`);
  return response.data;
};

/**
 * Update user profile
 * @param {Object} userData - User profile data to update
 * @returns {Object} Updated user data
 */
const updateProfile = async (userData) => {
  const response = await axiosInstance.put(`${AUTH_URL}/profile`, userData);
  return response.data;
};

/**
 * Upgrade user role (admin only)
 * @param {string} userId - User ID to upgrade
 * @param {Object} data - Role and status data
 * @returns {Object} Updated user data
 */
const upgradeUserRole = async (userId, data) => {
  const response = await axiosInstance.put(
    `${AUTH_URL}/upgrade-role/${userId}`,
    data
  );
  return response.data;
};

/**
 * Delete a user (admin only)
 * @param {string} userId - User ID to delete
 * @returns {Object} Success message
 */
const deleteUser = async (userId) => {
  const response = await axiosInstance.delete(`${AUTH_URL}/user/${userId}`);
  return response.data;
};

/**
 * Request password reset
 * @param {string} email - User email
 * @returns {Object} Success message
 */
const forgotPassword = async (email) => {
  const response = await axiosInstance.post(`${AUTH_URL}/forgot-password`, {
    email,
  });
  return response.data;
};

/**
 * Verify reset token
 * @param {string} token - Reset token
 * @returns {Object} Token validation result
 */
const verifyResetToken = async (token) => {
  const response = await axiosInstance.get(
    `${AUTH_URL}/reset-password/${token}/verify`
  );
  return response.data;
};

/**
 * Reset password
 * @param {string} token - Reset token
 * @param {string} password - New password
 * @returns {Object} Success message
 */
const resetPassword = async (token, password) => {
  const response = await axiosInstance.post(
    `${AUTH_URL}/reset-password/${token}`,
    { password }
  );
  return response.data;
};

const authService = {
  register,
  login,
  logout,
  getProfile,
  updateProfile,
  upgradeUserRole,
  deleteUser,
  forgotPassword,
  verifyResetToken,
  resetPassword,
};

export default authService;
